import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router =  new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('@/view/login.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/view/home.vue'),
      children:[
        {
          path: '/home/carOrder/carList',
          name: 'carList',
          component: () => import('@/view/carOrder/carList')
        },
        {
          path: '/home/carOrder/usedCarList',
          name: 'usedCarList',
          component: () => import('@/view/carOrder/usedCarList')
        },
        {
          path: '/home/person/personList',
          name: 'personList',
          component: () => import('@/view/person/personList')
        },
        {
          path: '/home/person/addPerson',
          name: 'addPerson',
          component: () => import('@/view/person/addPerson')
        },
        {
          path: '/home/address/addressList',
          name: 'addressList',
          component: () => import('@/view/address/addressList')
        },
        {
          path: '/home/address/addAddress',
          name: 'addAddress',
          component: () => import('@/view/address/addAddress')
        },
        {
          path: '/home/setting/commission',
          name: 'commission',
          component: () => import('@/view/setting/commission')
        },
        {
          path: '/home/group/setGroup',
          name: 'setGroup',
          component: () => import('@/view/group/setGroup')
        },
        {
          path: '/home/group/groupList',
          name: 'groupList',
          component: () => import('@/view/group/groupList')
        },
      ]
    }
  ]
})

//全局前置守卫
router.beforeEach((to,from,next) =>{
  //第一个参数to，包含的内容是切换后的路由对象，也就是跳转后的路由对象
  //第二个参数from，包含的内容的是切换前的路由对象，也就是跳转前的路由对象
  //第三个参数next()，是否往下执行，执行的话，如果不写的话路由就不会跳转，操作将会终止
  // console.log(to,from,'111')
  // if(from.name !== 'Login'){
  //   if(localStorage.getItem('userInfo')){
  //     next()
  //     return
  //   }
  //   localStorage.clear()
  //   next('/')
  // }
  next()
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js